export const RELEASE_PRODUCTS = [
  { label: "HovaStore", value: "HOVASTORE" },
  { label: "HovaHotel", value: "HOVAHOTEL" },
];

export const RELEASE_FLAVORS = [
  { label: "Base", value: "BASE" },
  { label: "EBM", value: "EBM" },
];

export const releaseTargetLabel = (record) => {
  const product =
    RELEASE_PRODUCTS.find((option) => option.value === record?.product_code)
      ?.label || record?.product_code || "HovaStore";
  const flavor =
    RELEASE_FLAVORS.find((option) => option.value === record?.flavor_code)
      ?.label || record?.flavor_code || "Base";
  return `${product} / ${flavor}`;
};
